import { FC } from "react";
import { ItemWidgetControllerProps } from "./types";
import { Column, Row } from "../../../../components/containers";
import { IconAnimation } from "../../../../components/animation";
import {
  ArrowLeftIcon,
  DashIcon,
  PlusWithoutCircleIcon,
  TrashIcon,
} from "../../../../assets/icons";
import { useWidgetStore, useThemeStore } from "../../../../stores";
import { Text } from "../../../../components/typography";
import { JustifyContent } from "../../../../components/containers/types";

const ItemWidgetController: FC<ItemWidgetControllerProps> = ({
  item,
  widget,
  edit,
}) => {
  const theme = useThemeStore((s) => s.theme);
  const rmWidgetFromItem = useWidgetStore((s) => s.rmWidgetFromItem);
  const incWidgetFlex = useWidgetStore((s) => s.incWidgetFlex);
  const decWidgetFlex = useWidgetStore((s) => s.decWidgetFlex);
  const setItemWidgetToLeft = useWidgetStore((s) => s.setItemWidgetToLeft);
  const setItemWidgetToRight = useWidgetStore((s) => s.setItemWidgetToRight);

  const onDecFlex = (): void => {
    decWidgetFlex(item.id, widget.id);
  };

  const onIncFlex = (): void => {
    incWidgetFlex(item.id, widget.id);
  };

  const onRmWidget = (): void => {
    rmWidgetFromItem(widget.name, item.id);
  };

  const onWidgetToLeft = (): void => {
    setItemWidgetToLeft(item.id, widget.id);
  };

  const onWidgetToRight = (): void => {
    setItemWidgetToRight(item.id, widget.id);
  };

  if (!edit) return <></>;
  return (
    <>
      <Row style={{ position: "absolute", bottom: 40, left: 5 }}>
        <Column
          background={theme.background}
          style={{ ...styles.iconCon, width: 16, height: 16 }}
          justifyContent={JustifyContent.Center}
        >
          <Text color={theme.textOnBg}>{widget.flex.toString()}</Text>
        </Column>
      </Row>

      <Row
        reverse
        style={{ position: "absolute", bottom: 5, left: 5 }}
        gap={10}
        props={{ onClick: (e) => e.stopPropagation() }}
      >
        <Column
          style={{ background: theme.background, ...styles.iconCon }}
          props={{ onClick: onDecFlex }}
        >
          <IconAnimation Icon={DashIcon} onHoverColor={theme.alert} />
        </Column>

        <Column
          style={{ background: theme.background, ...styles.iconCon }}
          props={{ onClick: onIncFlex }}
        >
          <IconAnimation
            Icon={PlusWithoutCircleIcon}
            onHoverColor={theme.primary}
          />
        </Column>

        <Column
          style={{ background: theme.background, ...styles.iconCon }}
          props={{ onClick: onRmWidget }}
        >
          <IconAnimation Icon={TrashIcon} onHoverColor={theme.alert} />
        </Column>

        <Column
          style={{ background: theme.background, ...styles.iconCon }}
          props={{ onClick: onWidgetToLeft }}
        >
          <IconAnimation Icon={ArrowLeftIcon} onHoverColor={theme.secondary} />
        </Column>

        <Column
          style={{
            background: theme.background,
            ...styles.iconCon,
            transform: "rotate(180deg)",
          }}
          props={{ onClick: onWidgetToRight }}
        >
          <IconAnimation Icon={ArrowLeftIcon} onHoverColor={theme.secondary} />
        </Column>
      </Row>
    </>
  );
};

export default ItemWidgetController;

const styles: Record<string, React.CSSProperties> = {
  iconCon: {
    padding: 5,
    borderRadius: 7,
    cursor: "pointer",
    boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
  },
};
